import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  badge: {
    backgroundColor: theme.colorPalette.green_10_op_30,
    borderRadius: theme.spacing(5),
    color: theme.colors.light_text,
    fontSize: 16,
    padding: theme.spacing(2, 4),
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    textAlign: 'center',
    whiteSpace: 'nowrap',
    maxWidth: 160
  }
});

export default makeStyles(styles);
